<template>
    <div class="inMiddle-area table-responsive horizontalScroll">
        <table class="table customize opencloseTrade-table" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'ACT'">
            <thead>
                <tr class="position-relative">
                    <!--volume and order need to ask---------->
                    <th v-if="row_ACT.includes(1)">{{$t('openOrder_tradeId')}}</th>
                    <!-- <th v-if="row_ACT.includes(2)">{{$t('AccountID')}}</th> -->
                    <th v-if="row_ACT.includes(2)">{{$t('closetrad_symbol')}}</th>
                    <th v-if="row_ACT.includes(3)">{{$t('closetrad_type')}}</th>
                    <!-- <th v-if="row_ACT.includes(5)">{{$t('quantity')}}</th> -->
                    <th v-if="row_ACT.includes(4)">{{$t('closetrad_price')}}</th>
                    <!-- <th v-if="row_ACT.includes(7)">{{$t('openTime')}}</th> -->
                    <th width="60" class="ExtraTableData">
                        <span class="tableoption dotAreaForButton" @click.prevent="actCheck = !actCheck"><feather type="more-vertical" size="1rem"></feather></span>
                        <div class="tablefilter box-shadow ListTabArea" v-if="actCheck">
                             <ul>
                                <li v-for="data,index in actList">
                                    <input v-model="row_ACT" :value="index+1" type="checkbox" :id="data+'_act'"  class="login_mt5">
                                    <label :for="data+'_act'" >{{data}} </label>
                                </li>
                             </ul>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'open_trades' in accountDetails &&  Object.keys(accountDetails.open_trades).length >0">
                <tr v-for="list in accountDetails.open_trades">
                    <td v-if="row_ACT.includes(1)">{{list.TradeID}}</td>
                    <!-- <td v-if="row_ACT.includes(2)">{{list.AccountID}}</td> -->
                    <td v-if="row_ACT.includes(2)">{{list.Symbol}} </td>
                    <td v-if="row_ACT.includes(3) && list.Side == 1">{{$t('buy')}}</td>
                    <td v-if="row_ACT.includes(3) && list.Side == 0">{{$t('sell')}}</td>
                    <!-- <td v-if="row_ACT.includes(5)">{{list.Quantity}}</td> -->
                    <td v-if="row_ACT.includes(4)">{{list.Price}}</td>

                    <td v-if="row_ACT.includes(5)">{{list.Price}}</td>
                    <!-- <td v-if="row_ACT.includes(7)">{{timeFuncDate(list.OpenTime)}}</td> -->
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="selectHere">
                    <td class="noRecordFound"  colspan="5"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('load_norecordfound')}}</p>
                    </td>
                </tr>
            </tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span" :list="accountDetails" v-else></loader-component>-->
        </table>
        
        <table class="table customize opencloseTrade-table" v-else-if="lastSelectTradingAccount != '' && (lastSelectTradingAccount[0].platform == 'MT4' || lastSelectTradingAccount[0].platform == 'ZULU')">
            <thead>
                <tr  class="position-relative">
                    <!-- <th v-if="row_MT4.includes(1)">{{$t('login')}}</th> -->
                    <th v-if="row_MT4.includes(1)">{{$t('closetrad_order')}}</th>
                    <th v-if="row_MT4.includes(2)">{{$t('closetrad_symbol')}}</th>
                    <th v-if="row_MT4.includes(3)">{{$t('closetrad_type')}}</th>
                    <th v-if="row_MT4.includes(4)">{{$t('closetrad_volume')}}</th>
                    <!-- <th v-if="row_MT4.includes(6)">{{$t('openTime')}}</th> -->
                    <th v-if="row_MT4.includes(5)">{{$t('closetrad_openPrice')}}</th>
                    <th v-if="row_MT4.includes(6)">{{$t('closetrad_PNL')}}</th>
                    <!-- <th v-if="row_MT4.includes(8)">{{$t('SL')}}</th>
                    <th v-if="row_MT4.includes(9)">{{$t('TP')}}</th>
                    <th v-if="row_MT4.includes(10)">{{$t('commision')}}</th>
                    <th v-if="row_MT4.includes(11)">{{$t('PNL')}}</th>
                    <th v-if="row_MT4.includes(12)">{{$t('comment')}}</th> -->
                    <th width="60" class=" ExtraTableData">
                        <span class="tableoption dotAreaForButton" @click.prevent="mt4Check = !mt4Check"><feather type="more-vertical" size="1rem"></feather></span>
                        <div class="tablefilter box-shadow ListTabArea" v-if="mt4Check">
                             <ul>
                                <li v-for="data,index in mt4List">
                                    <input v-model="row_MT4" :value="index+1" type="checkbox" :id="data+'_mt4'" class="login_mt5">
                                    <label :for="data+'_mt4'" >{{data}}</label>
                                </li>
                             </ul>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'open_trades' in accountDetails && Object.keys(accountDetails.open_trades).length >0 && accountDetails.open_trades.csv_array.length > 0">
                <tr v-for="list in accountDetails.open_trades.csv_array" >
                    <!-- <td v-if="row_MT4.includes(1)">{{list[1]}}</td> -->
                    <td v-if="row_MT4.includes(1)">{{list[0]}}</td>
                    <td v-if="row_MT4.includes(2)">{{decodeURIComponent(list[2])}}</td>
                    <td v-if="row_MT4.includes(3)">{{list[3].toUpperCase()}}</td>
                    <td v-if="row_MT4.includes(4)">{{list[4]/100}}</td>
                    <!-- <td v-if="row_MT4.includes(6)">{{timeFunc(list[5])}}</td> -->
                    <td v-if="row_MT4.includes(5)">{{list[6]}}</td>
                    <td v-if="row_MT4.includes(5)">{{list[9]}}</td>
                   <!--  <td v-if="row_MT4.includes(8)">{{list[7]}}</td>
                    <td v-if="row_MT4.includes(9)">{{list[8]}}</td>
                    <td v-if="row_MT4.includes(10)">{{list[10]}}</td>
                    <td v-if="row_MT4.includes(11)">{{list[9]}}</td>
                    <td v-if="row_MT4.includes(12)">{{list[11]}}</td> -->
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="selectHere">
                    <td class="noRecordFound"  colspan="5"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('load_norecordfound')}}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        
        <table class="table customize opencloseTrade-table" v-else-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'MT5'">
            <thead>
                <tr  class="position-relative">
                    <!-- <th v-if="row_MT5.includes(1)">{{$t('login')}}</th> -->
                    <th v-if="row_MT5.includes(1)">{{$t('closetrad_order')}}</th>
                    <th v-if="row_MT5.includes(2)">{{$t('closetrad_symbol')}}</th>
                    <th v-if="row_MT5.includes(3)">{{$t('closetrad_type')}}</th>
                    <th v-if="row_MT5.includes(4)">{{$t('closetrad_volume')}}</th>
                    <!-- <th v-if="row_MT5.includes(6)">{{$t('openTime')}}</th> -->
                    <th v-if="row_MT5.includes(5)">{{$t('closetrad_openPrice')}}</th>
                    <th v-if="row_MT5.includes(6)">{{$t('closetrad_PNL')}}</th>
                    <!-- <th v-if="row_MT5.includes(8)">{{$t('SL')}}</th>
                    <th v-if="row_MT5.includes(9)">{{$t('TP')}}</th>
                    <th v-if="row_MT5.includes(10)">{{$t('commision')}}</th>
                    <th v-if="row_MT5.includes(11)">{{$t('PNL')}}</th> -->
                    <th width="60" class="ExtraTableData">
                        <span class="tableoption dotAreaForButton" @click.prevent="mt5Check = !mt5Check"><feather type="more-vertical" size="1rem"></feather></span>
                        <div class="tablefilter box-shadow ListTabArea" v-if="mt5Check">
                             <ul>
                                <li v-for="data,index in mt5List">
                                    <input v-model="row_MT5" :value="index+1" type="checkbox" :id="data+'_mt5'" class="login_mt5">
                                    <label :for="data+'_mt5'" >{{data}}</label>
                                </li>
                             </ul>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' && 'open_trades' in accountDetails && Object.keys(accountDetails.open_trades).length >0 && accountDetails.open_trades.csv_array.length > 0">
                <tr v-for="list in accountDetails.open_trades.csv_array" >
                    <!-- <td v-if="row_MT5.includes(1)">{{list[1]}}</td> -->
                    <td v-if="row_MT5.includes(1)">{{list[0]}}</td>
                    <td v-if="row_MT5.includes(2)">{{decodeURIComponent(list[2])}}</td>
                    <td v-if="row_MT5.includes(3) && list[3] == 0">{{$t('buy')}}</td>
                    <td v-if="row_MT5.includes(3) && list[3] == 1">{{$t('sell')}}</td>
                    <td v-if="row_MT5.includes(4)">{{list[4]}}</td>
                    <!-- <td v-if="row_MT5.includes(6)">{{timeFunc(list[5])}}</td> -->
                    <td v-if="row_MT5.includes(5)">{{list[6]}}</td>
                    <td v-if="row_MT5.includes(6)">{{list[9]}}</td>
                   <!--  <td v-if="row_MT5.includes(8)">{{list[7]}}</td>
                    <td v-if="row_MT5.includes(9)">{{list[8]}}</td>
                    <td v-if="row_MT5.includes(10)">{{list[10]}}</td>
                    <td v-if="row_MT5.includes(11)">{{list[9]}}</td> -->
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="selectHere">
                    <td class="noRecordFound"  colspan="5"> 
                        <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                        <p>{{$t('load_norecordfound')}}</p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const }  from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import moment from 'moment'
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
        props:['pageName'],
        data() {
            return {
                col_span : 7,
                col_span1 : 13,
                row_ACT : [1,2,3,4],
                actCheck: false,
                actList:['tradeId','symbol','type','price', 'pnl'],
                row_MT4 : [1,2,3,4],
                mt4List:['order','symbol','type','volume','openPrice','pnl'],
                mt4Check: false,
                row_MT5 : [1,2,3,4],
                mt5List : ['order','symbol','type','volume','openPrice','pnl'],
                mt5Check: false,

            }
        },
        methods:{
            timeFunc(getData){
                return moment.unix(getData).format("DD-MM-YYYY, h:mm:ss");
            },
            timeFuncDate(getData){
                return moment(getData).format("DD-MM-YYYY, h:mm:ss");
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/open_trades_listing.vue